import LabelledCheck from "src/components/labelledcheck/LabelledCheck";
import styled from 'src/lib/styles/css';

//#region [Styles]
export const SScrollContainer = styled.div`
	overflow-y: auto;
	max-height: 60vh;
	@media (min-width: 550px) {
		max-height: 420px;
	}
`;

export const SFilterBlock = styled.div`
	display: flex;
	flex-wrap: wrap;
	padding: 10px;
	justify-content: flex-start;
`;

export const SLabelledCheck = styled(LabelledCheck)`
	flex: 0 1 auto;
`;

export const SControls = styled.div`
	margin-top: 10px;
	display: flex;
	justify-content: center;
	gap: 10px;
`;
//#endregion